import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { EntityInterface } from 'common/types/entities/EntityInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { FormSubentityTypeEnum } from 'src/shared/types/entities/form-interface'
import { v4 as uuid } from 'uuid'

export const generateId = () => uuid()

export const generateHtmlAttrId = (
  entityType:
    | EntityTypeEnum
    | keyof typeof structureTypes
    | FormSubentityTypeEnum,
) => `${entityType.toLowerCase().replace('_', '-')}-${uuid().slice(0, 8)}`

export const generateCustomHtmlAttrId = (
  entityType: EntityTypeEnum,
  customString: string,
) =>
  `${entityType.toLowerCase().replace('_', '-')}-${customString}${uuid().slice(0, 8)}`

export const insertChild = (
  childIds: string[],
  id: string,
  position: number,
) => [...childIds.slice(0, position), id, ...childIds.slice(position)]

export function generateBaseEntity<EntityType extends EntityTypeEnum>(
  type: EntityType,
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  const baseEntity: Omit<EntityInterface, 'type'> & { type: EntityType } = {
    id: generateId(),
    type,
    parentId,
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(type),
  }

  if (masterBlockId) {
    baseEntity.masterBlockId = masterBlockId
  }

  return baseEntity
}
